<div class="p-3">
  <h5 class="mb-3">🔻 Event-Manager</h5>
  @if (eventManagerEntries.length === 0) {
    <div
      class="text-muted small"
      >
      Keine Event-Manager Einträge vorhanden.
    </div>
  }
  @if (eventManagerEntries.length > 0) {
    <table
      class="table table-sm table-bordered"
      >
      <thead>
        <tr>
          <th>Key</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        @for (entry of eventManagerEntries; track entry) {
          <tr>
            <td class="font-monospace small">{{entry.key}}</td>
            <td class="font-monospace small">{{entry.value}}</td>
          </tr>
        }
      </tbody>
    </table>
  }

  <h5 class="mb-3 mt-4">🎬 Stage-Manager</h5>
  @if (stageManagerEntries.length === 0) {
    <div
      class="text-muted small"
      >
      Keine Stage-Manager Einträge vorhanden.
    </div>
  }
  @if (stageManagerEntries.length > 0) {
    <table
      class="table table-sm table-bordered"
      >
      <thead>
        <tr>
          <th>Key</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        @for (entry of stageManagerEntries; track entry) {
          <tr>
            <td class="font-monospace small">{{entry.key}}</td>
            <td class="font-monospace small">{{entry.value}}</td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
